import { configureStore } from "@reduxjs/toolkit";
import bgmReducer from "./features/bgm/BgmSlice";
import buttonEffectReducer from "./features/buttonEffect/ButtonEffectSlice";

export const store = configureStore({
    reducer: {
        bgm: bgmReducer,
        buttonEffect: buttonEffectReducer,
    },
});
